import React from 'react'

interface DragOverlayContentProps {
    itemType?: 'TEXT' | 'PRODUCT' | 'FILE' | 'COLOR' | 'EXTERNAL_IMAGE'
    colorValue?: string
    imageUrl?: string
}

const DragOverlayContent: React.FC<DragOverlayContentProps> = ({
    itemType,
    colorValue,
    imageUrl,
}) => {
    const renderIcon = () => {
        switch (itemType) {
            case 'COLOR':
                return (
                    <div
                        className="drag-overlay-color"
                        style={{
                            width: 16,
                            height: 16,
                            borderRadius: 4,
                            backgroundColor: colorValue || '#000',
                            border: '1px solid #ccc',
                        }}
                    />
                )

            case 'TEXT':
                return (
                    <svg
                        className="drag-overlay-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M17 6.1H3" />
                        <path d="M21 12.1H3" />
                        <path d="M15.1 18H3" />
                    </svg>
                )

            case 'PRODUCT':
            case 'FILE':
            case 'EXTERNAL_IMAGE':
                if (imageUrl) {
                    return (
                        <img
                            src={imageUrl}
                            alt="Drag item"
                            style={{
                                width: 16,
                                height: 16,
                                objectFit: 'cover',
                                borderRadius: 2,
                            }}
                        />
                    )
                }
                // fallback icon if imageUrl is invalid
                return (
                    <svg
                        className="drag-overlay-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <rect
                            width="18"
                            height="18"
                            x="3"
                            y="3"
                            rx="2"
                            ry="2"
                        />
                        <circle cx="9" cy="9" r="2" />
                        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                    </svg>
                )

            default:
                return null
        }
    }

    const renderLabel = () => {
        switch (itemType) {
            case 'COLOR':
                return colorValue
            case 'TEXT':
                return 'Text Block'
            default:
                return 'Image'
        }
    }

    return (
        <div className="d-flex align-items-center gap-2">
            {renderIcon()}
            <span>{renderLabel()}</span>
        </div>
    )
}

export default DragOverlayContent
